var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepActive2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_1472)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "#CB90FC",
    stroke: "#45185A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2196 20.5V19.161L14.8456 16.418C15.3656 15.872 15.7642 15.4387 16.0416 15.118C16.3276 14.7887 16.5269 14.507 16.6396 14.273C16.7522 14.039 16.8086 13.8007 16.8086 13.558C16.8086 13.1507 16.6786 12.83 16.4186 12.596C16.1672 12.362 15.8422 12.245 15.4436 12.245C15.0276 12.245 14.6679 12.3663 14.3646 12.609C14.0612 12.843 13.8402 13.1897 13.7016 13.649L12.1546 13.168C12.2586 12.6567 12.4709 12.2147 12.7916 11.842C13.1122 11.4607 13.5022 11.1703 13.9616 10.971C14.4296 10.763 14.9236 10.659 15.4436 10.659C16.0676 10.659 16.6136 10.7717 17.0816 10.997C17.5582 11.2223 17.9266 11.5387 18.1866 11.946C18.4552 12.3533 18.5896 12.83 18.5896 13.376C18.5896 13.7227 18.5246 14.065 18.3946 14.403C18.2646 14.741 18.0696 15.0877 17.8096 15.443C17.5496 15.7897 17.2116 16.1797 16.7956 16.613L14.5206 19.005H18.7196V20.5H12.2196Z",
    fill: "#45185A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_1472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepActive2);
export default __webpack_public_path__ + "static/media/StepActive2.226b0ab33529817093ed2a03b89f0927.svg";
export { ForwardRef as ReactComponent };